import { render } from "./EstimatedRevenuePerLeadReport.vue?vue&type=template&id=0b8e4f41"
import script from "./EstimatedRevenuePerLeadReport.vue?vue&type=script&lang=js"
export * from "./EstimatedRevenuePerLeadReport.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/felipe_admin_sr/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__